"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARAM_KEY = exports.ADDON_ID = void 0;
exports.register = register;
const jsx_runtime_1 = require("react/jsx-runtime");
const manager_api_1 = require("@storybook/core/manager-api");
const ControlsPanel_1 = __importDefault(require("./ControlsPanel"));
const Panel_1 = require("./Panel");
exports.ADDON_ID = 'RNCONTROLS';
exports.PARAM_KEY = 'controls';
function register() {
    manager_api_1.addons.register(exports.ADDON_ID, (api) => {
        manager_api_1.addons.add(exports.ADDON_ID, {
            type: manager_api_1.types.PANEL,
            title: 'Controls',
            render: ({ active }) => ((0, jsx_runtime_1.jsx)(Panel_1.AddonPanel, { active: active, children: (0, jsx_runtime_1.jsx)(ControlsPanel_1.default, { api: api }) })),
            paramKey: exports.PARAM_KEY,
        });
    });
}
